@if(importFileData) {
    <div class="col-12 flex align-items-center justify-content-start gap-2">
        <h3>Date : <span class="font-normal">{{ importFileData['date'] }}</span></h3>
        <p-button severity="success" label="Import Daily Summary" (onClick)="importSummaryData()" />
        <p-button severity="warning" label="Clear Previous Daily Summary Import" (onClick)="clearSummaryData()" />
    </div>

    <div class="col-12" *ngIf="importFileData?.['table']">

        <p-table [value]="importFileData['table']['rows']" [columns]="importFileData['table']['columns']">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    Ticket Collected Summary
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let column of columns">{{ column }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        {{ customer[col] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr>
                    <td colspan="3"></td>
                    <td>
                        {{ importFileData['table']['summary'][0]['Count'] }}
                    </td>
                    <td>
                        {{ importFileData['table']['summary'][0]['Total'] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns.length" class="text-center font-bold">No Data Found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
}